import { Validator } from '@vista-digital/validator';
export const nonEmptyStringValidator = Validator.string({ minLength: 1 });
//# sourceMappingURL=string.js.map